export default {
  'site.name': 'AllChinaBuy Spreadsheet',
  'site.tagline': 'Din Klogere Måde at Udforske AllChinaBuy På',
  'site.description': 'Udforsk AllChinaBuy-regnearket med produktlister, sælgerguider, QC-tips, forsendelsesoplysninger, anmeldelser og købsressourcer.',
  'nav.home': 'Hjem',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.guides': 'Guider',
  'nav.products': 'Produkter',
  'nav.sellers': 'Sælgere',
  'nav.shipping': 'Forsendelse',
  'nav.qc': 'QC',
  'nav.review': 'Anmeldelse',
  'nav.safety': 'Sikkerhed',
  'nav.articles': 'Artikler',
  'nav.language': 'Sprog',
  'nav.mainSite': 'Hovedside',
  'nav.shoppingGuide': 'Købsguide',
  'hero.title': 'AllChinaBuy Spreadsheet: Find Produkter, Sælgere & Købsguider',
  'hero.subtitle': 'Opdag organiserede AllChinaBuy-regnearksressourcer, produktguider, sælgerinformation, QC-tips, forsendelsesguider og praktiske købsråd ét sted.',
  'hero.cta.explore': 'Udforsk AllChinaBuy Spreadsheet',
  'hero.cta.guides': 'Gennemse Købsguider',
  'hero.cta.mainSite': 'Besøg Hovedside',
  'hero.search.placeholder': 'Søg efter spreadsheet, produkter, sælgere eller guider...',
  'categories.title': 'Populære Kategorier',
  'categories.subtitle': 'Gennemse vores kuraterede produktkategorier fra AllChinaBuy-spreadsheetet',
  'categories.all': 'Alle Kategorier',
  'features.title': 'Hvorfor Bruge AllChinaBuy Spreadsheet',
  'features.organized': 'Organiserede Produkter',
  'features.organized.desc': 'Alle produkter pænt kategoriseret og søgbare for nem opdagelse.',
  'features.sellers': 'Verificerede Sælgere',
  'features.sellers.desc': 'Find pålidelige sælgere med ratings og produktkvalitetsinformation.',
  'features.qc': 'QC Vejledning',
  'features.qc.desc': 'Lær kvalitetskontroltips for at sikre, at du får præcis det, du har bestilt.',
  'features.shipping': 'Forsendelsesinfo',
  'features.shipping.desc': 'Sammenlign forsendelsesmetoder, omkostninger og leveringstider til dit land.',
  'articles.title': 'Seneste Guider & Artikler',
  'articles.subtitle': 'Dybtgående ressourcer til at hjælpe dig med at handle klogere på AllChinaBuy',
  'articles.readMore': 'Læs Mere',
  'articles.allArticles': 'Se Alle Artikler',
  'products.title': 'Fremhævede Produkter',
  'products.subtitle': 'Gennemse kuraterede produkter fra AllChinaBuy-regnearket. Klik på et element for at hoppe til produktsiden og gennemføre dit køb.',
  'products.viewAll': 'Se Alle',
  'products.buy': 'Køb',
  'products.viewFull': 'Se Hele Spreadsheetet',
  'products.wantMore': 'Vil du se flere produkter?',
  'products.moreDesc': 'Udforsk det komplette AllChinaBuy-regneark med 10.000+ verificerede produkter i alle kategorier.',
  'products.visitFull': 'Besøg Hele Spreadsheetet',
  'cta.title': 'Klar til at Begynde at Handle?',
  'cta.subtitle': 'Besøg vores hovedside for at gennemse det komplette AllChinaBuy-regneark og starte din shoppingrejse.',
  'cta.button.main': 'AllChinaBuy Spreadsheet',
  'cta.button.buy': 'Køb Det Nu',
  'footer.about': 'Om',
  'footer.contact': 'Kontakt',
  'footer.privacy': 'Privatlivspolitik',
  'footer.terms': 'Servicevilkår',
  'footer.disclaimer': 'Ansvarsfraskrivelse',
  'footer.editorial': 'Redaktionel Politik',
  'footer.copyright': 'AllChinaBuy Spreadsheet. Uafhængig ressourcehub. Ikke tilknyttet AllChinaBuy.',
  'footer.disclaimerText': 'Dette websted er en uafhængig informationsressource og er ikke tilknyttet eller officielt godkendt af AllChinaBuy, medmindre det udtrykkeligt er angivet.',
  'lang.en': 'Engelsk',
  'lang.fr': 'Fransk',
  'lang.da': 'Dansk',
  'lang.de': 'Tysk',
  'seo.homeTitle': 'AllChinaBuy Spreadsheet – Produkter, Sælgere & Købsguider',
  'seo.homeDescription': 'Udforsk AllChinaBuy-regnearket med produktlister, sælgerguider, QC-tips, forsendelsesoplysninger, anmeldelser og købsressourcer.',
};